// 科学的介護推進に関する評価reducer.
import { Reducer } from 'redux';
import * as ScientificNursingCarePromotion from '../../constants/ScientificNursingCarePromotion';
import { ScientificNursingCarePromotionAction } from '../../actions/ScientificNursingCarePromotion';

export interface ScientificNursingCarePromotionState {
  Loading: boolean;
  LoadedCount: number;
  result: ScientificNursingCarePromotion.ScientificNursingCarePromotionData;
}

export const initialState = {
  Loading: false,
  LoadedCount: 0,
  result: {
    usersWithData: {},
  },
};

const scientificNursingCarePromotion: Reducer<
  ScientificNursingCarePromotionState,
  ScientificNursingCarePromotionAction
> = (state = initialState, action: any) => {
  switch (action.type) {
    case ScientificNursingCarePromotion.LOADING:
      return {
        ...state,
        type: ScientificNursingCarePromotion.LOADING,
        Loading: true,
        LoadedCount: 0,
      };
    case ScientificNursingCarePromotion.FINISH:
      return {
        ...state,
        type: ScientificNursingCarePromotion.FINISH,
        Loading: false,
        LoadedCount: state.LoadedCount + 1,
      };
    case ScientificNursingCarePromotion.SUCCESS:
      return {
        ...state,
        type: ScientificNursingCarePromotion.SUCCESS,
        Loading: false,
        result: {
          usersWithData: action.result?.usersWithData || {},
        },
      };
    case ScientificNursingCarePromotion.ERROR:
      return {
        ...state,
        type: ScientificNursingCarePromotion.ERROR,
        Loading: false,
        error: action?.result,
      };
    default:
      return state;
  }
};

export default scientificNursingCarePromotion;
